import React from "react";
import { TfiSearch } from "react-icons/tfi";
import { MdClose } from "react-icons/md";
import { SearchContainer } from "../../styled/setting";
import { toast } from "react-toastify";

const Search = ({ setSearched, searched, searchEvent, placeholder = "" }) => {
  const handleSearch = () => {
    if (!searched || searched.length < 2) {
      toast.error("검색어는 2글자 이상 입력해주세요.");
      return;
    }
    searchEvent();
  };

  const resetSearch = () => {
    setSearched("");
    searchEvent(true);
  };

  return (
    <SearchContainer className="search">
      <input
        type="text"
        onChange={(e) => setSearched(e.target.value)}
        value={searched}
        placeholder={placeholder}
        onKeyDown={(e) => handleEnterKey(e, handleSearch)}
      />
      {searched.length > 1 && (
        <button className="reset" onClick={resetSearch}>
          <MdClose />
        </button>
      )}
      <button onClick={handleSearch} className="searched">
        <TfiSearch />
      </button>
    </SearchContainer>
  );
};

export default Search;
